import React, { FC } from 'react';
import { Field, useFormikContext } from 'formik';
import Label from '../label/label';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import Description from '../description/Description';
import { requiredValidation, validateItemName, validateIntegerWithinBounds } from '../../utilities/Validation';

export const FloorDetails: FC = () => {
    const { translate } = useLocale()
    const { errors, values } = useFormikContext<any>();

    return <div>
        <div className="flex flex-row mb-2 mr-6">
            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='nameLabelId'>
                    <Label htmlFor='name'
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                    {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                </div>
                <div className="flex flex-row justify-between">
                    <Field
                        id='nameFieldId'
                        name="name"
                        type="text"
                        validate={(value) => validateItemName(value, translate)}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm bg-gray-input w-full" />
                </div>
            </div>

            <div className="flex flex-col flex-1 pr-3">
                <div className="flex flex-row justify-between" id='levelLabelId'>
                    <Label htmlFor='level'
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.level)}:</Label>
                    {errors.level ? <span className='text-red-600 text-xs'>{errors.level}</span> : null}
                </div>
                <div className="flex flex-row justify-between">
                        <Field
                            id='levelFieldId'
                            name="level"
                            type="number"
                            min={0}
                            validate={validateIntegerWithinBounds}
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm bg-gray-input w-full" />
                </div>
            </div>
        </div>

        <div className="flex flex-col flex-1 pr-8">
            <Description title={translate.byKey(TranslationKeys.notes)} modalDescription={true} />
        </div>
    </div >
}
